export default __webpack_public_path__ + "static/media/play.c46ad666.svg";